export default {
  methods: {
    nav(id) {
      this.$router.push({
        path: `/author/${id}`
      });
    },
    navTo(path) {
      this.$router.push({
        path
      });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
